/**
 * Returns the ordinal suffix for a given number.
 */
export const getOrdinal = (num: number | string, withNumber = false): string => {
  if (!Number(num)) {
    return '';
  }

  const suffixes = ['th', 'st', 'nd', 'rd'];
  const value = Number(num) % 100; // Handle 11, 12, 13 as exceptions
  let ordinalSuffix: string;
  if (value >= 11 && value <= 13) {
    ordinalSuffix = 'th';
  } else {
    ordinalSuffix = suffixes[Number(num) % 10] || 'th';
  }

  return withNumber ? `${num}${ordinalSuffix}` : ordinalSuffix;
};
